module.exports = __webpack_public_path__ + "static/mobile_home_banner-2af79f26d9f6f1acc9d200ee4a34ee29.png";